import React from 'react';
import { useParams } from 'react-router-dom';

import BasicLayout from 'components/BasicLayout';
import MenuList from 'components/MenuList';
import MenuListItem from 'components/MenuList/MenuListItem';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { faq as faqSchema } from 'i18n/faq/en-us.json';

import { SectionTitle } from './styles';

const FaqSection = () => {
  const { section } = useParams<{ section: string }>();
  const { t } = useStoreTranslation();

  return (
    <BasicLayout title={t('customerSupport.title')}>
      <SectionTitle>{t(`faq.${section}.title`)}</SectionTitle>
      <MenuList>
        {faqSchema[section].questions.map((_questionObj, i) => (
          <MenuListItem
            key={section + i}
            to={`/corporate/customerSupport/faq/${section}/${i}`}
            label={t(`faq.${section}.questions.${i}.question`)}
          ></MenuListItem>
        ))}
      </MenuList>
    </BasicLayout>
  );
};

export default FaqSection;
